
function dhx_outer_html(c) {
    if (c.outerHTML) {
        return c.outerHTML;
    }
    var a = document.createElement("DIV");
    a.appendChild(c.cloneNode(true));
    a = a.innerHTML;
    return a;
}

function dhx_li2trees(s, l, e) {
    for (var m = 0; m < s.childNodes.length; m++) {
        var r = s.childNodes[m];
        if (r.nodeType == 1 && r.tagName.toLowerCase() == "li") {
            var o = "";
            var n = null;
            var a = r.getAttribute("checked");
            for (var h = 0; h < r.childNodes.length; h++) {
                var g = r.childNodes[h];
                if (g.nodeType == 3) {
                    o += g.data;
                }
                else {
                    if (g.tagName.toLowerCase() != "ul") {
                        o += dhx_outer_html(g);
                    }
                    else {
                        n = g;
                    }
                }
            }
            l[l.length] = [e, o, a, r.id || l.length + 1];
            if (n) {
                l = dhx_li2trees(n, l, r.id || l.length);
            }
        }
    }
    return l;
}

export default dhx_li2trees;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dhx_li2trees.js